import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import {
    asyncDeleteParam,
    asyncReactivateParam,
} from '../../../../../../services/param.service';
import variables from '../../../../../../shared/styles/settings.module.scss';

import { useAuthContext } from '../../../../../../contexts/authContext';
import { REDIRECTEDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const useRedirectPqrListActions = (
    id: string | number,
    active: boolean,
    onActionComplete?: () => void
) => {
    const navigate = useNavigate();
    const { modeTheme } = useAuthContext();

    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        navigate(`${REDIRECTEDIT}/${id}`);
    };

    const TITLE_ACTIVE = active ? 'Inactivar' : 'Activar';
    const MESSAGE_ACTIVE = active ? 'inactivar' : 'activar';
    const MESSAGE_ACTIVE_OK = active ? 'inactivado' : 'activado';

    const handleDelete = () => {
        Swal.fire({
            title: TITLE_ACTIVE,
            text: '¿Está seguro que desea ' + MESSAGE_ACTIVE + ' el registro?',
            icon: 'question',
            iconColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            showDenyButton: true,
            denyButtonText: 'NO',
            denyButtonColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            confirmButtonText: 'SI',
            confirmButtonColor:
                modeTheme === 'darkMode'
                    ? variables.darkColor
                    : variables.primaryColor,
            customClass: 'swal-wide-class',
        }).then((response) => {
            if (response.isConfirmed) {
                (active ? asyncDeleteParam : asyncReactivateParam)(id).then(
                    (body: any) => {
                        if (body.items !== undefined) {
                            Swal.fire({
                                text:
                                    'Registro ' +
                                    MESSAGE_ACTIVE_OK +
                                    ' con éxito',
                                icon: 'success',
                                iconColor:
                                    modeTheme === 'darkMode'
                                        ? variables.darkColor
                                        : variables.primaryColor,
                            });
                            if (onActionComplete) onActionComplete();
                        } else {
                            Swal.fire({
                                text:
                                    'Error al ' +
                                    MESSAGE_ACTIVE +
                                    ' el registro',
                                icon: 'error',
                                iconColor:
                                    modeTheme === 'darkMode'
                                        ? variables.darkColor
                                        : variables.primaryColor,
                            });
                        }
                    }
                );
            }
        });
    };

    return {
        handleEdit,
        handleDelete,
    };
};
